export default __webpack_public_path__ + "static/media/ds-img.1660fe8c.png";